import React, { type ComponentType } from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/index.tsx';
import Placeholder from '@atlassian/jira-placeholder';
import { lazy } from '@atlassian/react-loosely-lazy';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyGICTrigger = lazy<ComponentType<{}>>(
	() => import(/* webpackChunkName: "async-cmp-gic-trigger" */ './index'),
);

const AsyncGlobalIssueCreateCMPTrigger = () => (
	<JSErrorBoundary
		id="async-cmp-gicTrigger"
		packageName="jira-software-backlog"
		teamName="a4t-tanuki"
	>
		<Placeholder name="cmp-gic-trigger" fallback={null}>
			<LazyGICTrigger />
		</Placeholder>
	</JSErrorBoundary>
);

export default AsyncGlobalIssueCreateCMPTrigger;
